import React, {Component} from 'react';

export class RowWithErrorHandler extends Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    componentDidCatch(error, info) {
        this.setState({hasError: true});
    }

    render() {
        if (this.state.hasError) {
            return (
                <tr title="Sorry, there was a problem loading information.
                    We're working on this.">
                    <td>
                        Ops! Hubo un problema al cargar :(
                    </td>
                </tr>
            );
        }

        return this.props.children;
    }
}
